import { EmailVerificationPage } from "@/interface/pages/email-verification-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/users/email-verification")({
  component: RouteComponent,
});

function RouteComponent() {
  return <EmailVerificationPage />;
}
